"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconTheme = exports.iconSizeVariant = void 0;
var _componentTheme = require("@clds/component-theme");
const iconTheme = (0, _componentTheme.createTheme)({
  xs: '0.5rem',
  sm: '0.75rem',
  md: '1rem',
  lg: '1.25rem',
  xl: '2rem',
  xxl: '2.625rem'
}, 'icon');
exports.iconTheme = iconTheme;
const iconSizeVariant = (0, _componentTheme.createVariant)(props => iconTheme[props.size]);
exports.iconSizeVariant = iconSizeVariant;
//# sourceMappingURL=theme.js.map